import { AbstractControl, ValidatorFn } from '@angular/forms'

export function phoneValidator(countryCodeCtrl: AbstractControl | null): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {

        const value = control.value;
        let countryCode;
        if (countryCodeCtrl != null){
            countryCode = countryCodeCtrl.value;
        }

        if (!value) {
            return null;
        }

        let isValid = false;

        if (countryCode && countryCode !== 'NO') {
            isValid = /^[0-9]{1,20}$/.test(value);            
        } else {
            isValid = /^[1-9][0-9]{7}$/.test(value);
        }

        return isValid ? null : { phoneFormatError: true };
    }
}